import React from "react";
import { useHistory, useParams } from "react-router-dom";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import { routes } from "../../helper/routes";
import { QuestionEditorProvider } from "../../context/assessSections/QuestionEditorContext";
import QuestionEditorForm from "./QuestionEditorForm";

export default function QuestionEditPage() {
  const history = useHistory();
  const { id } = useParams();

  return (
    <ContentWrapper>
      <QuestionEditorProvider
        includeAssessments={false}
        editQuestionId={id}
      >
        <QuestionEditorForm
          title="Edit Question"
          mode="edit"
          withAssessment={false}
          showCreateButton={false}
          onBack={() => history.push(routes.ques_lib)}
          onCancel={() => history.push(routes.ques_lib)}
        />
      </QuestionEditorProvider>
    </ContentWrapper>
  );
}